// src/pages/analiseLaboratorial/certificados/_components/FormAnexoCertificado/index.tsx
import { IFormValuesCertificadoAnalise } from "@/interfaces/IFormValuesCertificadoAnalise";
import { PlusOutlined } from "@ant-design/icons";
import { App, Col, Form, FormInstance, Row, Upload, UploadFile } from "antd";
import { RcFile } from "antd/lib/upload";

export function FormAnexoCertificado({
  form,
}: {
  form: FormInstance<IFormValuesCertificadoAnalise>;
}) {
  const anexoValue = Form.useWatch("anexo", form);
  const { notification } = App.useApp();

  // Garantir que sempre seja um array válido
  const arquivosSelecionados = Array.isArray(anexoValue) ? anexoValue : [];

  const converterParaBase64 = (file: RcFile): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const processarNovoArquivo = async (file: RcFile) => {
    try {
      const base64 = await converterParaBase64(file);

      const arquivoProcessado: UploadFile = {
        uid: file.uid,
        name: file.name,
        status: "done",
        size: file.size,
        type: file.type,
        url: base64,
        originFileObj: file,
      };

      form.setFieldValue("anexo", [arquivoProcessado]);
    } catch (error) {
      notification.error({
        message: "Falha no processamento",
        description: "Não foi possível processar o arquivo",
      });
    }

    return Upload.LIST_IGNORE;
  };

  const removerArquivo = (file: UploadFile) => {
    const arquivosAtualizados = arquivosSelecionados.filter(
      (item) => item.uid !== file.uid
    );
    form.setFieldValue("anexo", arquivosAtualizados);
  };

  const visualizarArquivo = async (file: UploadFile) => {
    let urlVisualizacao = file.url as string;

    if (!urlVisualizacao && file.originFileObj) {
      urlVisualizacao = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as RcFile);
        reader.onload = () => resolve(reader.result as string);
      });
    }

    if (urlVisualizacao) {
      const imageElement = new Image();
      imageElement.src = urlVisualizacao;
      const windowPreview = window.open(urlVisualizacao);
      windowPreview?.document.writeln(imageElement.outerHTML);
    }
  };

  return (
    <Row gutter={[8, 8]}>
      <Col xs={24}>
        <Form.Item
          label="Anexo"
          help="Formatos aceitos: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG"
          name="anexo"
          rules={[{ required: true, message: "Anexo é obrigatório" }]}
        >
          <Upload
            beforeUpload={processarNovoArquivo}
            showUploadList
            onPreview={visualizarArquivo}
            fileList={arquivosSelecionados}
            onRemove={removerArquivo}
            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
            listType="picture-card"
            maxCount={1}
          >
            {arquivosSelecionados.length === 0 && (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Adicionar</div>
              </div>
            )}
          </Upload>
        </Form.Item>
      </Col>
    </Row>
  );
}
